import React, { createContext, useContext } from 'react';

const SSRContext = createContext(false);

function usePageContext() {
  const useSSR = useContext(SSRContext);

  return { useSSR };
}

function PageProvider({ useSSR = false, children }) {
  return <SSRContext.Provider value={useSSR}>{children}</SSRContext.Provider>;
}

export { PageProvider, usePageContext };
